import React from 'react'

export const Avatar = ({image, isOnline}) => {
    return (
        <div className='avatar'>
            <img src={image} alt="avatar"/>
            <span className={`isOnline ${isOnline}`} />
        </div>
    )
}